module.exports = __webpack_public_path__ + "img/14-1.e2948be5.png";